import { BookingKitFilterState } from "../utils/booking-kit-filter-state";

export function useInitialValues(): {
  emptyValues: BookingKitFilterState | any;
  initialValues: BookingKitFilterState | any;
} {
  const emptyValues = {
    text: "",
    sort: "createdOn_asc",
    responsiblePerson: [],
    projectResponsiblePersonId: [],
    areaOfExpertise: [],
    consultantIds: [],
    customerIds: [],
    hasLegalPersonType: null,
    costCenter: [],
    managedBy: [],
    groupInvoicing: "null",
    isNational: false,
    consultantPayout: null,
    kitStatusFilter: [],
    bookingKitTagFilter: [],
    bookingDate: {
      from: null,
      to: null
    },
    kitTypes: []
  };

  const initialValues = {
    ...emptyValues
  };

  return {
    emptyValues,
    initialValues
  };
}
